<template>
	<!-- begin sidebar nav -->
	<ul class="nav" v-if="menus">
		<!-- <li class="nav-header">Navigation</li> -->
		<template v-for="menu in menus">
			<sidebar-nav-list 
				ref="sidebarNavList" 
				v-bind:menu="menu" 
				v-bind:scrollTop="scrollTop" 
				v-bind:key="menu.path" 
				v-bind:status="menu.status" 
				v-on:collapse-other="handleCollapseOther(menu)"
				v-on:showFloatSubmenu="handleShowFloatSubmenu"
				v-on:hideFloatSubmenu="handleHideFloatSubmenu"></sidebar-nav-list>
		</template>
		<!-- begin sidebar minify button -->
		<li><a href="javascript:;" class="sidebar-minify-btn" v-on:click="handleSidebarMinify()"><i class="fa fa-angle-double-left"></i></a></li>
		<!-- end sidebar minify button -->
	</ul>
	<!-- end sidebar nav -->
</template>

<script>
import SidebarMenu from './SidebarMenu.vue'
import SidebarNavList from './SidebarNavList.vue'
import PageOptions from '@/Options/PageOptions.js'

export default {
	name: 'SidebarNav',
	props: ['scrollTop'],
	components: {
		SidebarNavList
	},
	data () {
		return { 
			menus: null,
			pageOptions: PageOptions,
			modules: [],
		}
	},
	mounted () {
		const user = this.$store.getters.currentUser;
		const accountingMenuPaths = ['/dashboard/pengecekan', '/dashboard/monitoring'];
		const accountingMonitoringPaths = ['/dashboard/monitoring/status-sj', '/dashboard/monitoring/status-to'];

		const newSidebarMenu = SidebarMenu.map((val) => {
			if (user.role === 'ACCOUNTING' && val.path === '/dashboard/monitoring') {
				return {...val, children: val.children.filter(values => accountingMonitoringPaths.indexOf(values.path) !== -1)};
			}

			if (val.path === '/dashboard/settings') {
				return {...val, children: val.children.filter(values => !values.type || values.type === user.role)};
			}

			return val;
		}).filter(val => {
			if (user.role === 'ACCOUNTING') return accountingMenuPaths.indexOf(val.path) !== -1;
			return !val.type || val.type === user.role;
		});
		this.menus = newSidebarMenu;
	},
	methods: {
		handleShowFloatSubmenu: function(menu, offset) {
			this.$emit('showFloatSubmenu', menu, offset);
		},
		handleHideFloatSubmenu: function() {
			this.$emit('hideFloatSubmenu');
		},
		handleCollapseOther: function(menu) {
			for (var i = 0; i < this.menus.length; i++) {
				this.$refs.sidebarNavList[i].collapse(menu);
			}
		},
		handleSidebarMinify: function() {
			this.pageOptions.pageSidebarMinified = !this.pageOptions.pageSidebarMinified;
		},
		getModules () {
		let modules = JSON.parse(JSON.stringify(this.$store.state.modules))
		let userAccess = this.$store.getters.currentUser;

		if(userAccess.role.length == 0 || userAccess.role[0].id == 1){//Excluding Admins

		} else if (userAccess.role[0].id == 2) {//Excluding User Color
			modules = [
				{
					code : null,
					icon : 'fas fa-clipboard',
					path : '/work-order-listing',
					title : 'List Work Order'
				}
			]
		} else if(userAccess.role.length > 0){
			let i = 0;
			while(modules[i]){
				if(!modules[i].children){
					if (userAccess.permissions.indexOf(modules[i].code) == -1) modules.splice(i, 1);
					else i++;
				} else {
					let j = 0;
					while(modules[i].children[j]){
						if (userAccess.permissions.indexOf(modules[i].children[j].code) == -1) modules[i].children.splice(j, 1);
						else j++;
					}
					if(modules[i].children.length == 0) modules.splice(i, 1)
					else i++;
				}
			}
		}

		this.menus = modules;
		}
	}
}
</script>
